import { Container, Stack } from '@mantine/core';
import PageTitle from 'components/PageTitle';
import PAGES from 'constant/pages';
import { useAppName } from 'contexts/AppProvider';
import TableReviewMasterplan from 'modules/pages/dacum/reviewMasterplan/TableReviewMasterplan';
import React from 'react';

const ReviewMasterplanPage = () => {
  const { appName } = useAppName();
  return (
    <Container fluid>
      <Stack>
        <PageTitle
          title={PAGES[appName]?.reviewMasterPlan?.title || ''}
          description={PAGES[appName]?.reviewMasterPlan?.description || ''}
        />
        <TableReviewMasterplan />
      </Stack>
    </Container>
  );
};

export default ReviewMasterplanPage;
